export default __webpack_public_path__ + "static/media/book_bag-bw.5699897f.png";